import React from "react";
import { Link } from "react-router-dom";

export default function PortalSignupPage() {
  return (
    <div className="portal-shell--auth">
      <div className="portal-form portal-form--auth">
        <p className="eyebrow" style={{ color: "rgba(255,255,255,0.45)" }}>
          Portal
        </p>
        <h1 style={{ fontFamily: "var(--font-display)", letterSpacing: "-0.04em", marginBottom: "0.75rem" }}>
          Invitation only
        </h1>
        <p style={{ color: "rgba(255,255,255,0.62)", lineHeight: 1.55 }}>
          Public signup is closed. Portal access is limited to seeded IT-Patrol administrators. If you need an account,
          contact businessandadministration@it-patrol.tech.
        </p>
        <div className="portal-actions" style={{ marginTop: "1.25rem" }}>
          <Link className="btn" to="/portal/login">
            Sign in
          </Link>
          <Link className="btn btn--ghost" to="/" style={{ color: "inherit", borderColor: "rgba(255,255,255,0.35)" }}>
            Public site
          </Link>
        </div>
      </div>
    </div>
  );
}
